const mutations = {
  
    FAZER_LOGIN (state, status) {

        state.statusLogin = status

    },
}

export default mutations